<template>
  <div class="moldUseInformation table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      使用模具資訊
    </li>
    <b-table
      :items="moldUseInformationItem"
      :fields="moldUseInformationFields"
      sticky-header="186px"
      :no-border-collapse="noBorderCollapse"
      class="text-center moldUseInformation-table-detail"
    >
      <template #cell(used_life)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
      <template #cell(standard_life)="data">{{
        data.value.toLocaleString("en-US")
      }}</template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "moldUseInformation",
  data() {
    return {
      noBorderCollapse: true,
    };
  },
  computed: {
    ...mapGetters({
      moldUseInformationFields:
        "moldUseInformation/get_moldUseInformationFields",
      moldUseInformationItem: "moldUseInformation/get_moldUseInformationItem",
    }),
  },
};
</script>

<style lang="scss">
.moldUseInformation-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.moldUseInformation-table-detail thead th {
  border-top: 1px solid;
}
.moldUseInformation-table-detail th,
.moldUseInformation-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  vertical-align: middle !important;
}
.moldUseInformation-table-detail th:first-child,
.moldUseInformation-table-detail td:first-child {
  border-left: 1px solid;
}
.moldUseInformation-table-detail {
  margin-bottom: 0px;
}
.moldUseInformation-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}
.moldUseInformation-table-detail tr td {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/moldUseInformation.vue